import styled from '@emotion/styled';

export const CarouselContainer = styled.div`
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    position: relative;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
`;

export const CarouselWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 400px;

    @media (max-width: 1024px) {
        flex-direction: column;
        height: auto;
    }
`;

export const CarouselLeftSection = styled.div`
    flex: 1;
    padding: 40px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    position: relative;

    @media (max-width: 1024px) {
        padding: 30px 20px;
    }

    @media (max-width: 768px) {
        padding: 20px 15px;
    }
`;

export const CarouselContent = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const CarouselTitle = styled.h2`
    font-size: 36px;
    font-weight: 700;
    margin: 0 0 20px 0;
    line-height: 1.2;

    @media (max-width: 768px) {
        font-size: 28px;
    }

    @media (max-width: 480px) {
        font-size: 24px;
    }
`;

export const CarouselDescription = styled.p`
    font-size: 18px;
    line-height: 1.6;
    margin: 0 0 40px 0;
    opacity: 0.9;

    @media (max-width: 768px) {
        font-size: 16px;
        margin-bottom: 30px;
    }
`;

export const CarouselProgress = styled.div`
    margin-bottom: 20px;
`;

export const ProgressBar = styled.div`
    width: 100%;
    height: 6px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
    overflow: hidden;
`;

export const ProgressFill = styled.div`
    height: 100%;
    background: linear-gradient(90deg, #fff, #f0f0f0);
    border-radius: 3px;
    transition: width 0.05s linear;
`;

export const CarouselItems = styled.div`
    height: 120px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
`;

export const CarouselItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid transparent;
    min-width: 120px;
    height: 100px;
    flex: 1;

    &:hover {
        background: rgba(255, 255, 255, 0.15);
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }

    &.active {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.6);
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    }
`;

export const ItemIcon = styled.div`
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: white;
    margin-bottom: 8px;

    svg {
        width: 18px;
        height: 18px;
    }
`;

export const ItemContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
`;

export const ItemTitle = styled.h3`
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    color: white;
    text-align: left;
    line-height: 1.3;
`;

export const ItemDescription = styled.p`
    font-size: 10px;
    margin: 0;
    opacity: 0.8;
    color: white;
    text-align: left;
    line-height: 1.1;
`;

export const CarouselNavigation = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-shrink: 0;
    margin-top: auto;
    padding-top: 20px;
`;

export const CarouselButton = styled.button`
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: white;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }
`;

export const CarouselDots = styled.div`
    display: flex;
    gap: 8px;
`;

export const CarouselDot = styled.button`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.3);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.5);
        transform: scale(1.2);
    }

    &.active {
        background: white;
        transform: scale(1.3);
    }
`;

export const CarouselRightSection = styled.div`
    flex: 1;
    background: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;

    @media (max-width: 1024px) {
        padding: 30px 20px;
        min-height: 400px;
    }
`;

export const CarouselImageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

export const CarouselImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.05);
    }
`;
